import { TailwindColor } from '@repo/tailwind-config/tailwind.vars'

type Props = {
  color1: TailwindColor
  color2: TailwindColor
}

const LoginGroupFourIcon: React.FC<Props> = ({ color1, color2 }) => {
  return (
    <svg
      width="254"
      height="127"
      viewBox="0 0 254 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="127.05"
        cy="127.05"
        r="127.05"
        transform="rotate(90 127.05 127.05)"
        fill={color1}
      />
      <path
        d="M127.05 254.1C110.365 254.1 93.8441 250.814 78.4297 244.429C63.0153 238.044 49.0094 228.686 37.2117 216.888C25.414 205.09 16.0556 191.084 9.67071 175.67C3.28585 160.255 -0.000387753 143.734 -0.000387023 127.05C-0.000386294 110.366 3.28585 93.8445 9.67073 78.4301C16.0556 63.0156 25.414 49.0097 37.2117 37.2121C49.0094 25.4144 63.0153 16.056 78.4297 9.67109C93.8441 3.28624 110.365 -7.74143e-06 127.05 -5.55353e-06L127.05 127.05L127.05 254.1Z"
        fill="white"
      />
      <circle cx="126.525" cy="126.525" r="63.525" fill={color2} />
    </svg>
  )
}

export default LoginGroupFourIcon
